import {View} from 'MWC';
import tpl from './templates/interactive.jsx';
import widgetsHelper from 'utils/getWidget.helper';
import {apiback} from '../../config';
import {environment} from '../../environment/environment';

export default class extends View {
    template = tpl;
    constructor() {
        super();
        this.state = {
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
    }

    filterSlidesByEnvironment(slides) {
        if (window.location.href.includes('a-bank.com.ua')) {
            return slides.filter(slide => slide.prod === true);
        } else {
            return slides.filter(slide => slide.release === true);
        }
    }

    changeFilesUrl(url) {
        if (!url) {
            return null;
        } else if (url.includes('front-assets.a-bank')) {
            return url;
        } else {
            const img = 'img?';
            const file = 'file?';
            const sliceIndex = url.indexOf(img) !== -1 ? url.indexOf(img) : url.indexOf(file);
            return apiback('API_PAGES') + '/media/' + url.slice(sliceIndex);
        }
    }

    static displayName = 'Archive';
}
